export default __webpack_public_path__ + "static/media/xx59-on-table.bd62035f.png";